export default __webpack_public_path__ + "static/media/T12.3af5db1e.JPG";